import { render, staticRenderFns } from "./ChatMenu.vue?vue&type=template&id=2924bd5c&"
import script from "./ChatMenu.vue?vue&type=script&lang=js&"
export * from "./ChatMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChatMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VBtn,VIcon,VList,VListTile})
